import { render, staticRenderFns } from "./StatsKpiColumnAverage.vue?vue&type=template&id=ace040aa&scoped=true&"
import script from "./StatsKpiColumnAverage.vue?vue&type=script&lang=js&"
export * from "./StatsKpiColumnAverage.vue?vue&type=script&lang=js&"
import style0 from "./StatsKpiColumnAverage.vue?vue&type=style&index=0&id=ace040aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace040aa",
  null
  
)

export default component.exports